import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import Modal from 'react-modal'

class GiftCardAmount extends React.Component {
  constructor(props) {
    super(props)

    this.state = { showModal: false }
  }

  openModal(e) {
    e.preventDefault()
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  render() {
    const { cart: giftCard, updateCart: update, topComponent, paymentInfo } = this.props
    const { amounts, currency, data: { amount: selectedAmount } } = giftCard

    const amountButtons = amounts.map((amount, i) => {
      return (
        <button
          key={i}
          className={
            classNames('gift-card__amounts__grid__item', {
              'is-selected': amount === selectedAmount,
            })}
          onClick={() => update({ data: { amount } })}
        >{amount} {currency}</button>
      )
    })
    const top = topComponent
      ? (<div className="space--bottom-2">{ topComponent }</div>)
      : null

    return (
      <div className="reservation-step">
        <h1 className="reservation-step__title">
          <FormattedMessage id="app.cart.step.gift-card.title" />
        </h1>
        <div className="reservation-step__content">
          { top }
          <div className="grid">
            <div className="grid__item lap-6-12 space--bottom-1">
              <h2 className="beta space--bottom-1">
                <FormattedMessage
                  id="app.gift-card.cart.choose"
                />
              </h2>
              <div className="gift-card__amounts__grid">
                { amountButtons }
              </div>
            </div>
            <div className="grid__item lap-6-12">
              { paymentInfo }
            </div>
            <div className="grid__item form__actions">
              <button
                type="button"
                disabled={!selectedAmount}
                className="button--primary button--large"
                onClick={() => update({ step: 'infos' })}
              >
                <FormattedMessage id="app.cart.next" />
              </button>
            </div>
            <Modal
              isOpen={this.state.showModal}
              onRequestClose={this.closeModal.bind(this)}
            >
              { paymentInfo }
            </Modal>
          </div>
        </div>
      </div>
    )
  }
}

GiftCardAmount.propTypes = {
  cart: PropTypes.object.isRequired,
  updateCart: PropTypes.func.isRequired,
  topComponent: PropTypes.node.isRequired,
  paymentInfo: PropTypes.node.isRequired,
}

export default GiftCardAmount
